export default "__VITE_ASSET__DMQFdgXA__"